import React, { useEffect } from "react";
import { StyledGridRow, StyledGridCol } from "@/common/styles";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import TextField from "@/common/elements/InputElements/TextField";
import Select from "@/common/elements/InputElements/Select";
import { getOptionsFromRefList } from "@/util/common_function";
import { useSelector } from "react-redux";

const PersonalBasicInformation = ({ selectedAssociate, form }) => {
  useEffect(() => {
    // Only initialize if selectedAssociate exists and the form has not been modified yet.
    if (selectedAssociate) {
      form.setFieldsValue({
        lName: selectedAssociate.lName,
        fName: selectedAssociate.fName,
        mName: selectedAssociate.mName,
        suffix: selectedAssociate.suffix,
        daytimePhone: selectedAssociate.daytimePhone,
        phone: selectedAssociate.phone,
      });
    } else {
      form.setFieldsValue({
        lName: "",
        fName: "",
        mName: "",
        suffix: "",
        daytimePhone: "",
        phone: "",
      });
    }
  }, [selectedAssociate, form]);

  const phonePattern = /^[0-9-]*$/;
  const fullSearch = useSelector(state => state.fullSearch);

  return (
    <StyledGridRow gutter={16}>
      <StyledGridCol span={4}>
        <FormItem 
          label="Last Name" 
          name="lName"
          required={!fullSearch}
          rules={!fullSearch ? [{ required: true, message: "Last Name is required" }] : []}
        >
          <TextField />
        </FormItem>
      </StyledGridCol>
      <StyledGridCol span={4}>
        <FormItem 
          label="First Name" 
          name="fName"
          required={!fullSearch}
          rules={!fullSearch ? [{ required: true, message: "First Name is required" }] : []}
        >
          <TextField />
        </FormItem>
      </StyledGridCol>
      <StyledGridCol span={4}>
        <FormItem label="Middle Name" name="mName">
          <TextField />
        </FormItem>
      </StyledGridCol>
      <StyledGridCol span={3}>
        <FormItem label="Suffix" name="suffix">
          <Select
            options={getOptionsFromRefList("Suffix")}
            placeholder="Suffix"
            showSearch={false}
            variant="outlined"
          />
        </FormItem>
      </StyledGridCol>
      <StyledGridCol span={4}>
        <FormItem 
          label="Work Phone" 
          name="daytimePhone"
          rules={[
            {
              pattern: phonePattern,
              message: "Only numbers and dashes allowed",
            },
          ]}
        >
          <TextField />
        </FormItem>
      </StyledGridCol>
      <StyledGridCol span={4}>
        <FormItem 
          label="Home Phone" 
          name="phone"
          rules={[
            {
              pattern: phonePattern,
              message: "Only numbers and dashes allowed",
            },
          ]}
        >
          <TextField />
        </FormItem>
      </StyledGridCol>
    </StyledGridRow>
  );
};

export default PersonalBasicInformation;
